import { Alert, Anchor } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { Fragment } from 'react';
import { Link } from 'react-router';
import {
  FeedMatchExplanation,
  HolderSentence as HolderSentenceProps,
} from 'src/financial/financial-data/feedMatch';
import {
  describeHolder,
  ProviderReferenceHolder,
} from 'src/financial/financial-data/providerReferenceHolders';

const separator = (index: number, count: number) => {
  if (index === 0) {
    return '';
  }
  return index === count - 1 ? ' and ' : ', ';
};

const HolderLink = ({ holder }: { holder: ProviderReferenceHolder }) => {
  const { label, path } = describeHolder(holder);
  if (path === null) {
    return <>{label}</>;
  }
  return (
    <Anchor component={Link} to={path} inherit>
      {label}
    </Anchor>
  );
};

const HolderSentence = ({ lead, holders }: HolderSentenceProps) => (
  <>
    {' '}
    {lead}{' '}
    {holders.map((holder, index) => (
      <Fragment key={holder.asset_id}>
        {separator(index, holders.length)}
        <HolderLink holder={holder} />
      </Fragment>
    ))}
    .
  </>
);

export const FeedMatchWarning = ({ explanation }: { explanation: FeedMatchExplanation }) => (
  <Alert
    variant="light"
    color="yellow"
    radius="lg"
    icon={<IconAlertTriangle />}
    mb={'xxs'}
    data-testid="feed-match-warning"
  >
    {explanation.statement}
    {explanation.holderSentences.map(sentence => (
      <HolderSentence key={sentence.lead} {...sentence} />
    ))}{' '}
    {explanation.action}
  </Alert>
);
